module.exports = __webpack_public_path__ + "assets/img/36_571_big.a21b26a5.jpg";